export default __webpack_public_path__ + "css/status-page.css";